import { create } from 'zustand'
import type { Permission } from './permissions.env.ts'

interface PermissionsState {
	permissions: Permission[]
	setPermissions: (permissions: Permission[]) => void
}

const STORAGE_KEY = 'permissions'

const getInitialPermissions = (): Permission[] => {
	if (typeof window === 'undefined') return []

	try {
		const raw = window.localStorage.getItem(STORAGE_KEY)
		if (!raw) return []

		const parsed = JSON.parse(raw) as Permission[]
		if (!Array.isArray(parsed)) return []

		return parsed
	} catch {
		return []
	}
}

export const usePermissionsStore = create<PermissionsState>(set => ({
	permissions: getInitialPermissions(),
	setPermissions: permissions => {
		set({ permissions })

		if (typeof window === 'undefined') return

		try {
			window.localStorage.setItem(STORAGE_KEY, JSON.stringify(permissions))
		} catch {
			// ignore localStorage errors
		}
	}
}))
